module.exports = __webpack_public_path__ + "static/media/ar21_rmccarthy.a67009ec.jpeg";